import { render, staticRenderFns } from "./Bathroom.vue?vue&type=template&id=c94b8a50&scoped=true"
import script from "./Bathroom.vue?vue&type=script&lang=js"
export * from "./Bathroom.vue?vue&type=script&lang=js"
import style0 from "./Bathroom.vue?vue&type=style&index=0&id=c94b8a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94b8a50",
  null
  
)

export default component.exports